import React from "react";
import {withTranslation} from "react-i18next";
import {AlertTooltip} from "./AlertTooltip";
import {ConversionsAccountsDetail, hasAccountDetail} from "./ConversionsAccountsDetail";

export class ConversionsAlertTooltipClass extends AlertTooltip {
    render() {
        return (
            <div className="alert-tooltip">
                <div className="alert-tooltip-marker">
                    <i className="fa fa-circle" aria-hidden="true"/>
                </div>
                <div className="alert-tooltip-body conv-tooltip">
                    {this.renderHeader()}
                    {this.renderComparison()}
                    <div className="conv-tooltip-detail">
                        {this.renderAccounts()}
                    </div>
                    {this.renderClarifications()}
                </div>
            </div>
        );
    }

    /** El total del período y de dónde sale, que es lo primero que hay que poder leer. */
    renderHeader() {
        const {t} = this.props;
        return (
            <div className="conv-tooltip-head">
                <p className="conv-tooltip-total">
                    <span className="value">{this.props.value}</span>
                    <span className="unit">{t('conversions_alert_tooltip.conversions_this_period')}</span>
                </p>
                <p className="conv-tooltip-source">
                    {this.renderSourceTag()}
                    <span>{this.sourceSentence()}</span>
                </p>
                <p className="conv-tooltip-today">{this.todaySentence()}</p>
            </div>
        );
    }

    renderSourceTag() {
        const {t} = this.props;
        const isGa4 = this.props.conversionsSource && this.props.conversionsSource.is_ga4;
        return (
            <span className={`conversions-source-tag ${isGa4 ? '' : '-ads'}`}>
                {isGa4 ? t('conversions_source.ga4') : t('conversions_source.ads')}
            </span>
        );
    }

    /** Por qué el total sale de donde sale. En la celda no entraba; acá es lo que da contexto. */
    sourceSentence() {
        const {t} = this.props;
        const source = this.props.conversionsSource;
        if (!source || !source.is_ga4) {
            return t('conversions_alert_tooltip.source_ads');
        }
        return source.reason === 'GA4_REPLACING_PAID_MEDIA'
            ? t('conversions_alert_tooltip.source_ga4_by_configuration')
            : t('conversions_alert_tooltip.source_ga4_without_paid_media');
    }

    todaySentence() {
        const {t} = this.props;
        return this.hasValue(this.props.dayValue)
            ? t('conversions_alert_tooltip.today_with_conversions', {dayValue: this.props.dayValue})
            : t('conversions_alert_tooltip.today_without_conversions');
    }

    hasValue(formattedValue) {
        return Boolean(formattedValue) && parseFloat(String(formattedValue).replace(',', '.')) > 0;
    }

    renderComparison() {
        const {t} = this.props;
        if (!this.props.fluctuationPercentage || !this.props.expectedValue) {
            return null;
        }
        return (
            <p className={`conv-tooltip-comparison -${this.props.fluctuation}`}>
                <span className="delta">{this.props.fluctuationPercentage}</span>
                <span className="context">
                    {t('conversions_alert_tooltip.vs_last_period', {expectedValue: this.props.expectedValue})}
                </span>
            </p>
        );
    }

    /** El detalle, agrupado por la cuenta que lo midió. Lo comparte con el tooltip de Objetivo. */
    renderAccounts() {
        return <ConversionsAccountsDetail conversionsByAccount={this.props.conversionsByAccount}
                                          valueByType={this.props.valueByType}
                                          conversionsSource={this.props.conversionsSource}/>;
    }

    /** El estado de las cuentas cuando llega como texto mezclado entre los valores.
     *
     * Con el detalle agrupado la aclaración de cada cuenta viaja en su propio `status`, así que
     * esto sólo aplica a las filas guardadas antes del cambio. */
    renderClarifications() {
        const {t} = this.props;
        if (hasAccountDetail(this.props.conversionsByAccount) || !this.props.valueByType) {
            return null;
        }
        const clarifications = Object.entries(this.props.valueByType)
            .filter(([, value]) => typeof value === 'string');
        if (clarifications.length === 0) {
            return null;
        }
        return (
            <div className="conv-tooltip-foot">
                <p className="conv-tooltip-block-title">{t('conversions_alert_tooltip.clarifications')}</p>
                {clarifications.map(([name, value]) => (
                    <p key={name} className="conv-tooltip-account-status">
                        <span className="name">{name}</span>: {value}
                    </p>
                ))}
            </div>
        );
    }
}

export const ConversionsAlertTooltip = withTranslation()(ConversionsAlertTooltipClass);
export default ConversionsAlertTooltip;
